var exports = {
  "M": "x0a7806d5--33383d--slide",
};

module.exports = exports;
